import { mapActions, mapGetters } from 'vuex';

export default {
    computed: mapGetters('errors', ['hasErrors']),

    methods: {
        ...mapActions('errors', [
            'setErrors',
            'removeError',
            'clearErrors',
        ]),

        getError(form, field) {
            return this.$store.getters['errors/getError'](form, field);
        },

        hasError(form, field) {
            return this.$store.getters['errors/hasError'](form, field);
        },
    },
}
